import { all } from 'redux-saga/effects'
import { authWatcher } from '../reducers/auth-reducer'
import { generalStatisticsOneWatcher } from '../reducers/general-statistic-one-reducer'
import { generalStatisticsAllWatcher } from '../reducers/general-statistic-all-reducer'
import { organizationListWatcher } from '../reducers/organization-list-reducer'
import { bestSchoolWatcher } from '../reducers/BestSchool/bestSchoolReducer'
import { diseasedWeekWatcher } from '../reducers/Diseased/Week/diseasedWeekReducer'
import { diseasedMonthWatcher } from '../reducers/Diseased/Month/diseasedMonthReducer'
import { diseasedPeriodWatcher } from '../reducers/Diseased/Period/diseasedPeriodReducer'
import { candidatesWatcher } from '../reducers/Candidates/candidatesReducer'
import { diseasedCovidWatcher } from '../reducers/Diseased/Covid/diseasedCovidReducer'
import { studentsTotalWatcher } from '../reducers/StudentsTotal/studentsTotalReducer'
import { fileSharingWatcher } from '../reducers/fileSharing/fileSharingReducer'
import { phonebookWatcher } from '../reducers/Phonebook/phonebookReducer'
import { vaccinatedWatcher } from '../reducers/Vaccinated/vaccinatedReducer'
import { duplicatesWatcher } from '../reducers/Duplicates/duplicatesReducer'
import { connectFailsWatcher } from '../reducers/ConnectFails/connectFailsReducer'
import { privilegesWatcher } from '../reducers/Priveleges/privilegesReducer'
import { graduatesWatcher } from '../reducers/Graduates/graduatesReducer'
import { graduatesHEOWatcher } from '../reducers/GraduatesHEO/graduatesHEOReducer'
import { graduatOrientationWatcher } from '../reducers/GraduatesOrientation/graduatesOrientationReducer'
import { summGraduatesHEOWatcher } from '../reducers/SummGraduatesHEO/summGraduatesHEOReducer'
import { summGraduatesOrientationWatcher } from '../reducers/SummGraduatesOrientation/summGraduatesOrientationReducer'
import { giaWatcher } from '../reducers/GIA/giaReducer'
import { commissionWatcher } from '../reducers/Commission/commissionReducer'
import { hiringPlanWatcher } from '../reducers/HiringPlan/hiringPlanReducer'
import { staffInfoWatcher } from '../reducers/StaffInfo/staffInfoReducer'
import { performanceWatcher } from '../reducers/Performance/performanceReducer'
import { studentsInfoWatcher } from '../reducers/StudentsInfo/studentsInfoReducer'
import { applicantsWatcher, applicantDeleteWatcher } from '../reducers/Applicants/applicantsReducer'

export default function* rootSaga() {
  yield all([
    fileSharingWatcher(),
    authWatcher(),
    generalStatisticsAllWatcher(),
    generalStatisticsOneWatcher(),
    organizationListWatcher(),
    bestSchoolWatcher(),
    diseasedWeekWatcher(),
    diseasedMonthWatcher(),
    diseasedPeriodWatcher(),
    diseasedCovidWatcher(),
    candidatesWatcher(),
    studentsTotalWatcher(),
    phonebookWatcher(),
    vaccinatedWatcher(),
    duplicatesWatcher(),
    connectFailsWatcher(),
    privilegesWatcher(),
    graduatesWatcher(),
    graduatesHEOWatcher(),
    graduatOrientationWatcher(),
    summGraduatesHEOWatcher(),
    summGraduatesOrientationWatcher(),
    giaWatcher(),
    commissionWatcher(),
    hiringPlanWatcher(),
    staffInfoWatcher(),
    performanceWatcher(),
    studentsInfoWatcher(),
    applicantsWatcher(),
    applicantDeleteWatcher()
  ])
}
